<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10u1XqJ/text/images/cover.jpg?1684305842641" alt="This image is the cover for the book Pirate of the Prophecy, Empress of the Endless Sea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pirate of the Prophecy, Empress of the Endless Sea
      </h1>
      <p class="bookDescription body article font2">
        <p>On the world of Dematr, the Emperor and his legions rule over the lands on the eastern side of the Sea of Bakre, and the Great Guilds rule over the Emperor and his subjects. The Mechanics Guild, whose members claim they came from the stars, controls technology far beyond that of the swords and sailing ships of the common people, while the Mage Guild wields strange powers that terrify all who face them.<br/><br/>Jules, an orphan from the Imperial city of Landfall, has fought her way up to become an officer in training with the Emperor’s fleet. But her plans and her life are shattered when a Mage prophesizes that a daughter of her line will one day overthrow the Great Guilds and free the world. In that moment, the prophecy takes over her life. The Mages plot to kill her, the Mechanics try to find ways to use her, and the Emperor seeks to coerce her into having his children.<br/><br/>Unwilling to surrender her life to serving the prophecy, Jules makes her escape by joining the crew of a pirate ship. As she fights for her comrades’ freedom as well as her own, she learns that the world is finally changing. But if that change triggers all-out war between the Great Guilds and the Empire, it may well devastate the world rather than free it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Campbell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e498f5d0